import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import React from "react"

import { blockerCopy } from "./selectors"
import { CalendarMigrationBlocker } from "./types"

interface Props {
  blockers: CalendarMigrationBlocker[]
}

// Renders blocker codes through the user-safe copy map only. Raw codes,
// event titles, and UIDs must never appear here.
const MigrationBlockers = ({ blockers }: Props) => {
  if (blockers.length === 0) return null

  return (
    <ul className="mt-3 flex flex-col gap-2">
      {blockers.map((blocker) => (
        <li key={blocker.code} className="flex items-start gap-2 rounded-lg bg-gray-ultralight p-3 text-sm">
          <ExclamationCircleIcon className="mt-0.5 size-5 flex-none text-gray-dark" aria-hidden="true" />
          <span>
            {blockerCopy(blocker.code)}
            {blocker.count && blocker.count > 1 ? ` (${blocker.count} items)` : ""}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default MigrationBlockers
